var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardBody, Text } from 'grommet';
import { Checkmark, Close } from 'grommet-icons';
import { Bullet } from '../Bullet';
var FeatureBullet = function (_a) {
    var label = _a.label, _b = _a.enabled, enabled = _b === void 0 ? false : _b, _c = _a.highlight, highlight = _c === void 0 ? false : _c;
    return (_jsxs(Box, __assign({ direction: "row", pad: "xxsmall", margin: "small" }, { children: [_jsx(Bullet, { background: 
                // eslint-disable-next-line no-nested-ternary
                highlight ? "white" : enabled ? "status-ok" : "status-critical", icon: enabled ? (_jsx(Checkmark, { color: highlight ? "status-ok" : "light-1", size: "small" })) : (_jsx(Close, { color: highlight ? "status-critical" : "light-1", size: "small" })) }), _jsx(Text, __assign({ style: { textDecoration: enabled ? undefined : "line-through" }, margin: { horizontal: "small" }, size: "small" }, { children: label }))] })));
};
FeatureBullet.defaultProps = {
    highlight: false,
    enabled: false,
};
export var PlanBody = function (_a) {
    var features = _a.features, highlight = _a.highlight;
    return (_jsx(CardBody, __assign({ margin: "small", background: highlight ? "brand" : "background-front" }, { children: features.map(function (feature) { return (_jsx(FeatureBullet, { highlight: highlight, enabled: feature.enabled, label: feature.name }, feature.name)); }) })));
};
PlanBody.defaultProps = {
    highlight: false,
};
//# sourceMappingURL=PlanBody.js.map